var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.805,
    height: 37.719,
    viewBox: "0 0 39.805 37.719",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image-upload",
    transform: "translate(-2.227 -2.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7560",
    "data-name": "Trac\\xE9 7560",
    d: "M41.985,14.743V31.275a6.885,6.885,0,0,1-7.637,7.637H9.91a6.885,6.885,0,0,1-7.637-7.637V10.91A6.885,6.885,0,0,1,9.91,3.274H27.832a.611.611,0,0,1,.58.743A9.138,9.138,0,0,0,41.148,14.169a.611.611,0,0,1,.837.574Z",
    transform: "translate(0 1.012)",
    fill: "#396ce8",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7561",
    "data-name": "Trac\\xE9 7561",
    d: "M37.173,19.08l-9.066-9.066a2.049,2.049,0,0,0-2.892,0l-10.06,10.06a1.018,1.018,0,0,1-1.426,0L11.815,18.16a2.049,2.049,0,0,0-2.892,0L3.929,23.153a.611.611,0,0,0-.179.432V24.86c0,3.218,1.364,4.582,4.582,4.582H32.77c3.218,0,4.582-1.364,4.582-4.582V19.512a.611.611,0,0,0-.179-.432Z",
    transform: "translate(1.578 7.427)",
    fill: "#396ce8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7562",
    "data-name": "Trac\\xE9 7562",
    d: "M9.3,12.841A2.546,2.546,0,0,1,9.282,7.75H9.3a2.546,2.546,0,1,1,0,5.091Z",
    transform: "translate(4.683 5.7)",
    fill: "#396ce8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7563",
    "data-name": "Trac\\xE9 7563",
    d: "M25.947,5.752,22.892,2.7a1.529,1.529,0,0,0-2.159,0L17.679,5.752A1.527,1.527,0,0,0,19.837,7.91l.448-.446v4.458a1.527,1.527,0,0,0,3.055,0V7.464l.448.446a1.527,1.527,0,0,0,2.159-2.159Z",
    transform: "translate(15.59 0)",
    fill: "#396ce8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);
export default __webpack_public_path__ + "static/media/image-upload.6332c6039cba3f9c7d7f99a69a9d17d2.svg";
export { ForwardRef as ReactComponent };